import React, {useEffect} from 'react';
import { IoArrowUpCircleOutline } from "react-icons/io5";

export default function BookingCencel() {

      const bookingStep = [
        {
            engStep:"Please visit our website :- www.padampura.com",
            hindiStep:'कृपया हमारी वेबसाइट मे क्लिक करे: www.padampura.com'
        },
        {
            engStep:"Please login the website by using your username and password.",
            hindiStep:'कृपया अपने उपयोगकर्ता नाम और पासवर्ड का उपयोग करके वेबसाइट लॉगइन करें ।'
        },
        {
            engStep:"If you don’t have username, please sign up by registering the required details.",
            hindiStep:'यदि आपके पास उपयोगकर्ता नाम नहीं है, तो कृपया आवश्यक विवरण दर्ज करके साइन अप करें।'
        },
        {
            engStep:"At the left corner, please select place of stay (Select Dharmashala), your arrival date, and arrival time, date of departure and time of departure. Click on “check availability” button.",
            hindiStep:'बाएं कोने पर, कृपया ठहरने का स्थान (धर्मशाला का चयन करें), अपने आगमन की तारीख और आगमन का समय, प्रस्थान की तारीख और प्रस्थान का समय चुनें। "उपलब्धता की जांच करें" बटन पर क्लिक करें।'
        },
        {
            engStep:"Select the room as per the availability and book it by clicking “Book Now” button.",
            hindiStep:'उपलब्धता के अनुसार कमरे का चयन करें और "बुक नाउ" बटन पर क्लिक करके बुक करें |'
        },
        {
            engStep:"Fill All Necessary detail, then click processed to checkout option. A new window will open. Click “I accept” term and condition check box and click “proceed” to payment and make payment by Debit/credit card/net banking/UPI etc.",
            hindiStep:'सभी आवश्यक विवरण भरें, फिर चेकआउट विकल्प के लिए संसाधित पर क्लिक करें। एक नयी विंडो खुलेगी। "मैं स्वीकार करता हूं" शब्द और शर्त चेक बॉक्स पर क्लिक करें और डेबिट / क्रेडिट कार्ड / नेट बैंकिंग आदि द्वारा भुगतान करने और भुगतान करने के लिए "आगे" पर क्लिक करें।'
        },
        {
            engStep:"As soon as your reservation is completed, a success page will appear on the screen with all the information of your reservation and you will receive an email and a SMS confirming your booking.",
            hindiStep:'जैसे ही आपका आरक्षण पूरा हो जाता है, आपके आरक्षण की सभी जानकारी के साथ स्क्रीन पर एक सफलता पृष्ठ दिखाई देगा और आपको एक ईमेल और एक एसएमएस प्राप्त होगा जो आपकी बुकिंग की पुष्टि करेगा।'
        },
      ]

      const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth" 
        });
      };

      useEffect(() => {
        scrollToTop();
      }, []);

  return (
    <div>
        <div className='container mt-5'>
           <p className='text-center' style={{ fontFamily:"Poppins", fontSize:"2em", fontWeight:600 }} >ONLINE BOOKING & CANCEL STEPS</p>
           <p className='text-start' style={{ fontFamily:"Poppins", fontSize:"1.1em", fontWeight:600, color:'#1f5156' }} >Online Booking Steps :</p>
             <table className="table table-bordered border-dark">
                <thead>
                    <tr></tr>
                </thead>
                <tbody>
                    {
                        bookingStep.map((item, index)=>{
                            return(
                              <tr key={index}>
                                 <th>{index + 1}.</th>
                                 <th>
                                    <div style={{ fontFamily:"Poppins", fontSize:".8em", fontWeight:500 }}>{item.engStep}</div>
                                    <div style={{ fontFamily:"Poppins", fontSize:".8em", fontWeight:500 }}>{item.hindiStep}</div>
                                 </th>
                              </tr>
                            )
                        })
                    }
                </tbody>
             </table>
        </div>
        <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width:40,height:40, backgroundColor:"red", color:"#fff", alignItems:"center", justifyContent:"center", display:"flex" }}><IoArrowUpCircleOutline style={{ fontSize:40 }} /></button>
    </div>
  )
}
